import baseStyled, { ThemedStyledInterface, keyframes } from "styled-components";
export const theme = {
  font: {
    mainFont: "MainFont",
    styledFont: "StyledFont",
  },
  color: {
    primary: "#b51f04",
    secondary: "#e07b39",
    header: "#FFFFFF",
    text: "#494949",
    lightText: "#E3E3E3",
    valid: "#0D9353",
    invalid: "#DD3E3E",
    boxConnector: "#DD3E3E",
    scrollbar: "#DD3E3E",
  },
  mobileFirst: {
    breakPoint: "768px",
  },
  notebook: {
    breakPoint: "1600px",
  },
  icons: {
    navigationArrow: `${process.env.PUBLIC_URL}/assets/icons/arrowLeft.svg`,
    closeCross: `${process.env.PUBLIC_URL}/assets/icons/closeCross.svg`,
    boxVisited: `${process.env.PUBLIC_URL}/assets/icons/boxVisited.svg`,
    boxLocked: `${process.env.PUBLIC_URL}/assets/icons/boxLocked.svg`,
    resourcePdfFile: `${process.env.PUBLIC_URL}/assets/icons/resourcePdfFile.svg`,
    resourceHyperLink: `${process.env.PUBLIC_URL}/assets/icons/resourceHyperLink.svg`,
    resourceDefaultIcon: `${process.env.PUBLIC_URL}/assets/icons/resourceDefaultIcon.svg`,
  },
  footer: {
    height: "4em",
    mobileHeight: "8em",
  },
};
export type Theme = typeof theme;
export const styled = baseStyled as ThemedStyledInterface<Theme>;
export type styledAnimation = typeof keyframes;
export type StyleSheet = { [key: string]: React.CSSProperties };
